import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Box, Link, List, ListItem, ListItemText, Typography } from "@material-ui/core";

import "./About.css";

const AboutPage = () => {
    const { t } = useTranslation();
    const configuration = useSelector(state => state.configuration);

    return (
        <Box className="aboutpage">
            <Box>
                <Typography variant="h5">{t("About.title")}</Typography>
                <Typography>{t("About.version", { version: configuration.commitHash ? `${configuration.version}-${configuration.commitHash}` : configuration.version })}</Typography>
                <Typography>{t("About.schema", { schema: configuration.schema })}</Typography>
            </Box>

            <Box>
                <br />
                <List dense>
                    <Typography variant="h6">{t("About.acknowledgments")}</Typography>
                    <ListItem>
                        <ListItemText>
                            HTML Agility Pack. Copyright 2006-2010 Microsoft Corporation. All rights reserved. Trademark
                            information is available{" "}
                            <Link href="http://www.microsoft.com/mscorp/ip/trademarks/">here.</Link>
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>Buyers Lab. Copyright 2014 Buyers Laboratory. All rights reserved</ListItemText>
                    </ListItem>
                </List>
            </Box>

            <Box>
                <br />
                <Typography variant="h6">{t("About.warning")}</Typography>
                <Typography>{t("About.warningMessage")}</Typography>
            </Box>

            {!configuration.showWelcomeMessage ? null : (
                <Box className="bottom-welcome-message">
                    <br />
                    <Typography>{configuration.welcomeMessage.reduce((a, c) => a + " " + c)}</Typography>
                </Box>
            )}
        </Box>
    );
};

export default AboutPage;
